import { cn } from "../cn";

/** The `outline` chip's classes, for a toggle row that picks several rather than one. */
export function outlineChip(on: boolean): string {
  return cn(
    "h-8 rounded-full border px-3 text-ui",
    on
      ? "border-ink bg-ink text-ground"
      : "border-rule-strong bg-surface text-ink-2 hover:text-ink",
  );
}
